import { useQuery } from "react-query";
import { UserAccountsService } from "../gen/clients/llts";
import { useUserSession } from "./useUserSession";

/**
 * Custom hook to fetch enabled applications for the current user.
 * This replaces the deprecated userAccount.applications field.
 */
export const useEnabledApplications = () => {
  const { username } = useUserSession();

  return useQuery(["getEnabledApplications", username], {
    queryFn: UserAccountsService.getEnabledApplications,
    enabled: !!username,
    select: data => data.applicationIds
  });
};
